import { Planet, PlanetSkillType } from '@apeiron/planet'
import { Box, styled } from '@mui/material'
import { PlanetDetailSectionTitle } from '@src/components/planet/detail/PlanetDetailSectionTitle'
import PlanetSkillsSection from '@src/components/planet/detail/planetSkillsSection/PlanetSkillsSection'
import { SectionContent } from '@src/components/planet/detail/SectionContent'
import SkillDescriptionTab from '@src/components/share/skill/SkillDescriptionTab'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const MainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`

const TitleContainer = styled(Box)`
  align-items: center;
  display: flex;
`

const StyledPlanetDetailSectionTitle = styled(PlanetDetailSectionTitle)`
  flex: 1;
`

const PlanetSkillMainSection: FC<Props> = (props: Props) => {
  const { planet, className } = props

  const { t } = useTranslation()

  return (
    <MainContainer className={className}>
      <TitleContainer>
        <StyledPlanetDetailSectionTitle
          title={t('planet.detail.skill.title')}
          subTitle={t('planet.detail.skill.title')}
        />
        <SkillDescriptionTab />
      </TitleContainer>

      <SectionContent>
        <PlanetSkillsSection
          planet={planet}
          title={t('planet.detail.auto_attack.title')}
          types={[PlanetSkillType.AutoAttack]}
        />
        <PlanetSkillsSection
          planet={planet}
          title={t('planet.detail.boon_skills.title')}
          types={[
            PlanetSkillType.PlanetPassive,
            PlanetSkillType.PlanetEnergize
          ]}
        />
        <PlanetSkillsSection
          planet={planet}
          title={t('planet.detail.card_skills.title')}
          types={[PlanetSkillType.Active]}
        />
        <PlanetSkillsSection
          planet={planet}
          title={t('planet.detail.perk_skills.title')}
          types={[PlanetSkillType.Passive]}
        />
      </SectionContent>
    </MainContainer>
  )
}

type Props = {
  className?: string
  planet: Planet
}

export default PlanetSkillMainSection
